module.exports = __webpack_public_path__ + "img/ico_btn_change_address.37c3627.svg";